import Raven from 'raven-js/dist/raven.js';

function config(additionalOptions = {}) {
  let data, datafound, error;
  let alarm = function(msg) {
    console.warn(msg);
    return Raven.captureMessage(msg);
  };

  let merge = function(src, dest) {
    for (let attr in src) {
      dest[attr] = src[attr];
    }
    return dest;
  };

  let environment = 'production';
  let extra = {};

  let dataContainer = document.querySelector('#monitoring-data');
  let dataFound = false;
  if (dataContainer != null) {
    try {
      data = JSON.parse(dataContainer.innerHTML);
      if (data.isStaging) { environment = 'nonprod'; }
      extra = data;
      datafound = true;
    } catch (error1) { error = error1; }
  }

  if (!datafound) { alarm(`Unable to find monitoring data (${window.location.host})`); }

  let opts = {
    environment,
    extra
  };

  // Default catch-all project, see https://sentry.io/yext-lf/pages-catch-all/
  Raven.config('https://c2aa9e4b33324a6189d67c785eea56d4@constable.yextpages.net/114090', merge(additionalOptions, opts));
}

function reportAjaxErrors() {
  if (typeof jQuery !== 'undefined' && jQuery !== null) {
    // Automatic AJAX error notification, see https://docs.sentry.io/clients/javascript/tips/ for more info
    jQuery(document).ajaxError(function(event, jqXHR, ajaxSettings, thrownError) {
      if (Raven.isSetup()) {
        Raven.captureMessage(thrownError || jqXHR.statusText, {
          extra: {
            type: ajaxSettings.type,
            url: ajaxSettings.url,
            data: ajaxSettings.data,
            status: jqXHR.status,
            error: thrownError || jqXHR.statusText,
            response: (jqXHR.responseText != null ? jqXHR.responseText.substring(0, 100) : undefined)
          }
        });
      }
    });
  }
}

export function Enable() {
  Raven.install();
}

export function Disable() {
  Raven.uninstall();
}

export function MonitoringInit(additionalOptions = {}) {
  config(additionalOptions);
  reportAjaxErrors();

  if (Raven._globalOptions.environment == 'nonprod') {
    console.log("Sentry is disabled by default in a staging environment. To enable, please run 'Monitoring.Enable()'");
  } else {
    Enable();
  }
}
